import { useMemo } from 'react'

import { Chip } from '@mui/material'
import type { Assistant } from 'types/graphql'

import { logger } from 'src/lib/logger'

const GoalChip = ({
  goalId,
  assistant,
}: {
  goalId: string
  assistant: Assistant
}) => {
  const goal = useMemo(
    () => assistant?.goals?.find((goal) => goal?.id === goalId),
    [assistant, goalId]
  )

  logger.dev('GoalChip', {
    goal,
    goalId,
    assistantGoals: assistant?.goals,
    assistant,
  })
  return goal ? <Chip label={goal?.name} /> : null
}

export default GoalChip
